<template>
  <svg width="0" height="0" style="position: absolute" aria-hidden="true">
    <defs>
      <linearGradient id="wing" x1="0" y1="0" x2="1" y2="1">
        <stop stop-color="#f8e2b3" />
        <stop offset=".5" stop-color="#c9a467" />
        <stop offset="1" stop-color="#745032" />
      </linearGradient>
      <symbol id="butterfly" viewBox="0 0 200 150">
        <path
          d="M99 77C67 12 6 6 13 45c3 20 34 41 72 43C34 76 17 98 33 115c18 21 51-5 66-29C112 112 147 136 165 115c17-20-4-41-52-28 37-5 66-25 73-47C199 0 130 15 101 77Z"
          fill="url(#wing)"
        />
        <path
          d="M99 60q-6-19-15-23m17 23q8-20 17-23M100 59v46"
          stroke="#efd6a5"
          stroke-width="2"
          fill="none"
        />
        <path
          d="M22 35l72 45M43 24l49 54M177 32l-70 49M150 25l-43 53M38 106l53-18M157 108l-48-20"
          stroke="#382416"
          stroke-width="1"
          opacity=".45"
        />
      </symbol>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "ButterflySvgDefs",
};
</script>
